export const portfolioDataFr = {
    name: "Belghith Adem",
    title: "Développeur Full-Stack",
    contact: {
      email: "BelghithAdem20@gmail.com",
      phone: "+216 54 021 345",
      location: "Tunisie, Ariana",
      linkedin: "https://linkedin.com/in/belghith-adem-92982b197",
      github: "https://github.com/BelghithAdem",
      gitlab: "https://gitlab.com/BelghithAdem",
      portfolio: "https://belghithadem.netlify.app/"
    },
    profile: "Ingénieur logiciel Full-Stack spécialisé dans le développement d'applications web modernes, performantes et scalables. Expérience sur des projets SaaS, monorepo et architectures frontend modernes.",
    experience: [
      {
        title: "Développeur Full Stack",
        company: "1for1 Learning",
        location: "Sousse, Tunisie",
        date: "01/2026 – Présent",
        tasks: [
          "Développement d'applications web full-stack avec Next.js et NestJS.",
          "Création de services backend scalables et d'interfaces frontend modernes.",
          "Poste à temps plein en présentiel."
        ],
        technologies: [
          "Next.js",
          "NestJS"
        ]
      },
      {
        title: "Développeur Front-End",
        company: "Wee Farm",
        location: "Tunisie",
        date: "09/2025 – 12/2025",
        tasks: [
          "Développement d'interfaces performantes avec Next.js.",
          "Travail en monorepo (Turborepo) pour améliorer la scalabilité.",
          "Mise en place de Storybook et création de composants UI réutilisables.",
          "Collaboration avec l'équipe produit."
        ],
        technologies: [
          "Next.js",
          "TypeScript",
          "Turborepo",
          "Storybook",
          "Tailwind CSS"
        ]
      },
      {
        title: "Développeur Full-Stack",
        company: "Tadkik",
        location: "Tunisie",
        date: "05/2025 – 09/2025",
        tasks: [
          "Développement front-end d'un SaaS multi-tenant avec Vue 3.",
          "Intégration d'API REST et gestion des accès.",
          "Création de dashboards analytiques et fonctionnalités de planification.",
          "Développement de composants UI réutilisables."
        ],
        technologies: [
          "Vue.js",
          "TypeScript",
          "Tailwind CSS",
          "Chart.js",
          "FullCalendar",
          "Mercure",
          "shadcn/ui"
        ]
      },
      {
        title: "Développeur Front-End",
        company: "Synque",
        location: "Hong Kong",
        date: "01/2024 – 06/2025",
        tasks: [
          "Création de pages web dynamiques avec des composants modulaires utilisant Vue.js.",
          "Refonte d'une application React Native pour optimiser performances et scalabilité.",
          "Participation au développement d'un projet Next.js avec des fonctionnalités front-end modernes."
        ],
        technologies: [
          "Vue.js",
          "React Native",
          "Tailwind CSS",
          "Next.js"
        ]
      },
      {
        title: "Développeur Full-Stack – Stage d'Été",
        company: "NEXT STEP",
        location: "Charguia Tunis",
        date: "08/2025 – 09/2025",
        tasks: [
          "Développement de services API scalables avec FastAPI.",
          "Conception d'interfaces utilisateur modernes avec Next.js.",
          "Intégration de fonctionnalités LLM pour fournir des suggestions intelligentes."
        ],
        technologies: [
          "FastAPI",
          "MongoDB Atlas",
          "Next.js",
          "Node.js",
          "Google Gemini",
          "LLM",
          "LangChain"
        ]
      },
      {
        title: "Développeur – Stage d'Été",
        company: "Orange Tunisia",
        location: "Tunisie",
        date: "07/2025 – 08/2025",
        tasks: [
          "Création d'un tableau de bord KPI en temps réel avec Grafana.",
          "Extraction et nettoyage des données à partir de fichiers CSV.",
          "Connexion et intégration de la base de données avec Grafana pour la visualisation du tableau de bord."
        ],
        technologies: [
          "Python",
          "ClickHouse",
          "Grafana",
          "REST APIs",
          "SSH"
        ]
      }
    ],
    projects: [
      {
        name: "RentSmart",
        date: "2024 – Présent",
        image: "/images/projects/rentsmart.png",
        github: "",
        live: "https://play.google.com/store/apps/details?id=hk.com.rentsmart&hl=fr",
        category: "professional",
        type: "Application mobile (iOS & Android)",
        description: [
          "Application React Native & Expo iOS et Android pour le paiement du loyer à Hong Kong.",
          "Payer son loyer par carte bancaire, cumuler des miles et du cashback. 10 k+ téléchargements sur Google Play.",
          "RentSmart - 交租有「里」賞. Résidentiel, commercial, parking, dépôts et frais d'agence."
        ]
      },
      {
        name: "California Gym Music",
        date: "2024 – Présent",
        image: "/images/projects/california.png",
        github: "",
        live: "https://music.california-gym.com",
        category: "professional",
        type: "Système de gestion musicale",
        description: [
          "Système de gestion musicale Next.js & Node.js pour la salle et les cours California Gym.",
          "Intégration Spotify, planification, publicités et playlists depuis Spotify ou fichiers.",
          "Gestion de la musique dans les salles (salle cours et autres salles)."
        ]
      },
      {
        name: "WeeFarm",
        date: "2024 – Présent",
        image: "/images/projects/wee-farm.png",
        github: "",
        live: "https://wee-farm.com/en",
        category: "professional",
        description: [
          "Plateforme e-commerce pour agriculteurs développée avec Next.js et backend Node.js/Express.",
          "Intégration de la passerelle de paiement Konnect Pay pour des transactions sécurisées.",
          "Solution full-stack connectant les agriculteurs aux clients, avec gestion de produits et traitement des commandes."
        ]
      },
      {
        name: "Tech Gateway",
        date: "01/2025 – 03/2025",
        image: "/images/projects/techgateway.png",
        github: "",
        live: "https://techgateway.com.tn",
        category: "professional",
        description: [
          "Site e-commerce WordPress complet avec optimisation SEO avancée.",
          "Intégration paiements sécurisés, gestion des stocks et analytics.",
          "Performance optimisée, responsive design et référencement naturel."
        ]
      },
      {
        name: "Dhiya Store",
        date: "12/2024 – 02/2025",
        image: "/images/projects/dihyastore.png",
        github: "",
        live: "https://dihyastore.com/",
        category: "professional",
        description: [
          "Boutique en ligne WordPress spécialisée dans la poterie et décoration.",
          "Catalogue complet avec pots, mugs, assiettes et objets décoratifs.",
          "Système de commande personnalisée et cours de poterie intégrés."
        ]
      },
      {
        name: "Quran App",
        date: "03/2024 – 04/2024",
        image: "/images/projects/qran.png",
        github: "https://github.com/BelghithAdem/quran-app",
        live: "https://quran-web-app.pages.dev/",
        category: "academic",
        description: [
          "Application web moderne pour la lecture du Coran.",
          "Interface utilisateur intuitive avec Vue 3 + Vite.",
          "Fonctionnalités de recherche et navigation avancées."
        ]
      }
    ],
    skills: {
      frontend: [
        { name: "Vue.js", level: "Pro" },
        { name: "React", level: "Pro" },
        { name: "Next.js", level: "Pro" },
        { name: "React Native", level: "Pro" },
        { name: "Expo", level: "Pro" },
        { name: "Tailwind CSS", level: "Pro" },
        { name: "TypeScript", level: "Pro" }
      ],
      backend: [
        { name: "Node.js", level: "Pro" },
        { name: "NestJS", level: "Pro" },
        { name: "FastAPI", level: "Pro" },
        { name: "WebSocket", level: "Pro" },
        { name: "Python", level: "Pro" }
      ],
      databases: [
        { name: "PostgreSQL", level: "Pro" },
        { name: "MySQL", level: "Pro" },
        { name: "MongoDB", level: "Pro" },
        { name: "Redis", level: "Pro" },
        { name: "Vector Database", level: "Pro" }
      ],
      devops: [
        { name: "Docker", level: "Pro" },
        { name: "Kubernetes", level: "Pro" },
        { name: "GitLab CI/CD", level: "Pro" },
        { name: "AWS", level: "Pro" },
        { name: "Helm", level: "Pro" },
        { name: "Prometheus", level: "Pro" },
        { name: "Grafana", level: "Pro" },
        { name: "Storybook", level: "Pro" },
        { name: "Turborepo", level: "Pro" }
      ],
      ai: [
        { name: "Generative AI", level: "Pro" },
        { name: "Agentic AI", level: "Pro" },
        { name: "LangChain", level: "Pro" },
        { name: "LangGraph", level: "Pro" },
        { name: "Semantic Search", level: "Pro" },
        { name: "RAG Pipeline", level: "Pro" },
        { name: "Prompt Engineering", level: "Pro" },
        { name: "Google Gemini", level: "Pro" },
        { name: "OpenAI API", level: "Pro" }
      ]
    },
    education: [
      {
        institution: "Tek-up",
        location: "Ariana, Tunisie",
        program: "Cycle d'Ingénieur en Informatique - Diplôme d'Ingénieur en Génie Logiciel et Systèmes d'Information",
        date: "2023 – 2026"
      },
      {
        institution: "ISET",
        location: "Kairouan, Tunisie",
        program: "Licence en Technologie Informatique - Spécialisé en technologie informatique",
        date: "2020 – 2023"
      }
    ],
    certifications: [
      {
        name: "Full Stack Spring Boot 3",
        issuer: "Udemy",
        date: "2024",
        url: "https://www.udemy.com/certificate/UC-45a85e28-6ba5-4ef9-bb27-1094c0b73426/"
      },
      {
        name: "Docker Certification",
        issuer: "Udemy",
        date: "2023",
        url: "https://www.udemy.com/certificate/UC-25dc890e-931f-448a-91ad-9b65be392408/"
      },
      {
        name: "Agile Fundamentals",
        issuer: "SCRUMstudy",
        date: "2024",
        url: "https://www.scrumstudy.com/certification/verify?type=SFC&number=1009321"
      }
    ],
    languages: {
      "Anglais": "Courant",
      "Français": "Compétent",
      "Arabe": "Langue maternelle"
    }
  }; 